// Shared form helpers used across wizard step components.

export function Field({ label, testId, error, children, help }) {
  return (
    <div>
      <label className="form-label">{label}</label>
      {children}
      {help && !error && (
        <p className="text-xs text-muted-brand mt-1">{help}</p>
      )}
      {error && (
        <p
          className="error-text"
          data-testid={testId ? `error-${testId}` : undefined}
        >
          {error}
        </p>
      )}
    </div>
  );
}

export function YesNoToggle({ value, onChange, testIdBase }) {
  return (
    <div className="flex gap-2" data-testid={`${testIdBase}-toggle`}>
      <button
        type="button"
        onClick={() => onChange("no")}
        className={`radio-card ${value === "no" ? "active" : ""}`}
        data-testid={`${testIdBase}-no`}
      >
        No
      </button>
      <button
        type="button"
        onClick={() => onChange("yes")}
        className={`radio-card ${value === "yes" ? "active" : ""}`}
        data-testid={`${testIdBase}-yes`}
      >
        Yes
      </button>
    </div>
  );
}
